module.exports = __webpack_public_path__ + "static/blueprints-for-building-better-girls-c8d7a39d58d60ab2fbd902d2120f2ee7.jpg";